import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as CheckboxBlankIcon } from 'src/assets/icons/checkbox-blank.svg';
import { ReactComponent as CheckboxSelectedIcon } from 'src/assets/icons/checkbox-selected.svg';
import { baseTheme } from '../baseTheme';

const { palette } = baseTheme;

export default {
  defaultProps: {
    checkedIcon: <SvgIcon component={CheckboxSelectedIcon} />,
    icon: <SvgIcon component={CheckboxBlankIcon} />,
    size: 'small',
  },
  styleOverrides: {
    root: {
      color: palette.neutral.main,
      '&:hover': {
        color: palette.primary.light,
      },
    },
  },
};
